<ng-container *transloco="let t; read: 'flexTimeCorrection'">
  <h2 class="mbm">{{ t("title") }}</h2>
  <kendo-grid
    [data]="flexTimeCorrections"
    (cancel)="cancelHandler($event)"
    (save)="saveHandler($event)"
    (remove)="removeHandler($event)"
    (add)="addHandler($event)"
    [style.maxHeight.px]="600"
  >
    <ng-template kendoGridToolbarTemplate>
      <button kendoGridAddCommand>{{ t("add") }}</button>
    </ng-template>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="employeeId"
      [title]="t('employee')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.employeeId | employee | async }}
      </ng-template>
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
        let-isNew="isNew"
      >
        <kendo-formfield>
          <kendo-dropdownlist
            [data]="employees$ | async"
            textField="lastName"
            valueField="id"
            [valuePrimitive]="true"
            [formControl]="formGroup.get('employeeId')"
          >
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              {{ dataItem.firstName }} {{ dataItem.lastName }}
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              {{ dataItem?.firstName }} {{ dataItem?.lastName }}
            </ng-template>
          </kendo-dropdownlist>
          <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
        </kendo-formfield>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="date"
      [title]="t('date')"
      width="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.date | date : "dd.MM.yyyy" }}
      </ng-template>
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
        let-isNew="isNew"
      >
        <kendo-formfield>
          <kendo-datepicker
            [formControl]="formGroup.get('date')"
          ></kendo-datepicker>
          <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
        </kendo-formfield>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="hours"
      [title]="t('hours')"
      width="100"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-maskedtextbox
          [value]="dataItem.hours"
          [mask]="mask"
          [readonly]="true"
        >
        </kendo-maskedtextbox>
      </ng-template>
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
      >
        <kendo-formfield>
          <kendo-maskedtextbox
            [formControl]="formGroup.get('hours')"
            [mask]="editMask"
            [includeLiterals]="true"
            [rules]="maskRules"
          >
          </kendo-maskedtextbox>

          <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
        </kendo-formfield>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="flexTimeCorrectionType"
      [title]="t('flexTimeCorrectionType')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{
          t(
            "flextimeCorrectionType." +
              flexTimeCorrectionType[dataItem.flextimeCorrectionType]
          )
        }}
      </ng-template>
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
        let-isNew="isNew"
      >
        <kendo-formfield>
          <kendo-dropdownlist
            [data]="flextimeCorrectionTypes"
            [formControl]="formGroup.get('flexTimeCorrectionType')"
            [valuePrimitive]="true"
            textField="name"
            valueField="id"
          ></kendo-dropdownlist>
          <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
        </kendo-formfield>
      </ng-template>
    </kendo-grid-column>

    <!-- Only present while overtime is active for the tenant; otherwise affectsOvertime stays false. -->
    <kendo-grid-column
      media="(min-width: 450px)"
      field="affectsOvertime"
      [title]="t('affectsOvertime')"
      *ngIf="(tenantSettings$ | async)?.hasOvertime"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.affectsOvertime ? t("affectsOvertimeOn") : t("affectsOvertimeOff") }}
      </ng-template>
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
      >
        <kendo-formfield>
          <kendo-dropdownlist
            [data]="affectsOptions"
            [formControl]="formGroup.get('affects')"
            [valuePrimitive]="true"
            textField="name"
            valueField="id"
            (valueChange)="onAffectsChange($event)"
          ></kendo-dropdownlist>
        </kendo-formfield>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="description" [title]="t('description')">
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
      >
        <kendo-formfield>
          <kendo-textbox
            [formControl]="formGroup.get('description')"
          ></kendo-textbox>
          <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
        </kendo-formfield>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column [title]="t('action')" [width]="250">
      <ng-template kendoGridCellTemplate let-isNew="isNew">
        <button kendoGridRemoveCommand>{{ t("delete") }}</button>
        <button
          kendoGridSaveCommand
          themeColor="primary"
          [disabled]="formGroup?.invalid"
        >
          {{ isNew ? t("add") : t("save") }}
        </button>
        <button kendoGridCancelCommand>
          {{ isNew ? t("discard") : t("cancel") }}
        </button>
      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoGridNoRecordsTemplate>
      {{ t("noResults") }}
    </ng-template>
  </kendo-grid>

  <app-delete-confirm-dialog
    [(opened)]="deletionDialogOpened"
    [message]="t('deletionMessage')"
    (confirmed)="deleteConfirmed()"
  ></app-delete-confirm-dialog>
</ng-container>
